import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PatientPersonalInfo,patientRefData,PatientfirstInakeData, auth } from 'src/app/models/verifypatient/verifypatient';
import { ExitingpatientService } from 'src/app/services/exitingpatient.service';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { NgxSpinnerService } from 'ngx-spinner';
declare var $: any;

@Component({
  selector: 'app-madison-referal',
  templateUrl: './madison-referal.component.html',
  styleUrls: ['./madison-referal.component.css']
})
export class MadisonReferalComponent implements OnInit {


// Ref_person: any = 'Mursalin' ;
// visit_reason : any = 'Podiatry';
// Long_going : any = 'since 2 months';
 
questionnaire_one : any = '';


 Is_injured : boolean = false;
 patientPersonalInfo: PatientPersonalInfo;
 patientIntakeData : patientRefData = new patientRefData ();
 patientFirstInakeData : PatientfirstInakeData = new PatientfirstInakeData ();

  constructor(private router: Router,private _login: ExitingpatientService,private _phrutilService: PhrutillsService,private phrUtils: PhrutillsService,private spinner: NgxSpinnerService) { 

    let info = localStorage.getItem('PersonalInfo');
     this.patientPersonalInfo = this.phrUtils.decrypt(info) as PatientPersonalInfo;
  }

  ngOnInit(): void {
  }

  checkInjuryStatus(data : any ){

  let type = data.value;
  this.patientIntakeData.visitReason = type;
    if(type.toLowerCase().includes("injury")){
    this.Is_injured= true;
    }
    else{
      this.Is_injured= false;
    }
  }

  Injured(){
 
  if (this.patientIntakeData.refPerson == '' && this.patientIntakeData.duration == '' && this.patientIntakeData.visitReason == '') {

    this._phrutilService.showInfo("At least one field is mandatory.");    
    return

  }  
 
 else {
    // this.questionnaire_one= 
    //  'Who may we thank for referring our office: ' + this.patientRefdata.Ref_person + ', ' + 
    // ' What is your reason for visit: ' +  this.patientRefdata.visit_reason + ', ' +
    // ' How long has this been going on: ' + this.patientRefdata.Long_going + ' ';

    if(this.Is_injured){

                         
                         this.patientFirstInakeData.Ref_person = this.patientIntakeData.refPerson;
                         this.patientFirstInakeData.visit_reason = this.patientIntakeData.visitReason;
                         this.patientFirstInakeData.Long_going = this.patientIntakeData.duration;
       
                         this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
                         this.router.navigateByUrl("/madison-inj", { state: { unReadFaxCount: this.patientFirstInakeData} })
                          })
             //this.router.navigateByUrl("/madison-inj");
                }else{

                    this.spinner.show();
                    this.patientIntakeData.patientAccount = this.patientPersonalInfo.PATIENT_ACCOUNT;
                    this.patientIntakeData.practiceCode = this.patientPersonalInfo.PRACTICE_CODE;
                    this.patientIntakeData.isPatientInjured = "";
                   // this.sendInjdata.additionalDetail = '';
                    //  patientAccount : any ;
                    //  practiceCode : any ; 
                    //  description : any ;
                    //  additionalDetail : any; 
                  
                    this._login.SaveInjurydetails(this.patientIntakeData).subscribe((res: any) => {
        
                      this.spinner.hide();
                      if (res && res.statusCode == 200) {
              
                        this._phrutilService.showSuccess("Record saved successfully");

                        this.router.navigateByUrl("/intake");
                       //this.router.navigateByUrl("/patient/intake/allergy");
                      } else {
                        this._phrutilService.showError("Some error occured.");
                      }
                    }, (error: any) => {
                     
                      this._phrutilService.showError("Some error occured.");
                      this.spinner.hide();
                    });

                     }

   }
  }

}
